const templateBomsCustomSelect = document.createElement("template");

templateBomsCustomSelect.innerHTML = `
    <style>
        * {
            box-sizing: border-box;
        }
        :host {
            position: relative;
            width: 100%;
            display: block;
            max-width: 400px;
        }
        .boms-custom-select_selected {
            padding: 18px 24px 18px 24px;
            border-radius: 50px;
            border: none;
            font-size: 16px;
            background-color: #F1F1F1;
            outline: none;
            max-width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            line-height: 20px;
        }
        .boms-custom-select_selected svg{
            width: 20px;
            height: 20px;
            transition: all 0.3s ease;
        }
        .boms-custom-select_list {
            position: absolute;
            left: 0;
            max-width: 100%;
            width: 100%;
            background-color: #fff;
            box-shadow: 0px 4px 7px 0px #00000012;
            border-radius: 12px;
            z-index: 100;
            display: grid;
            grid-template-rows: 0fr;
            transition: grid-template-rows 0.3s ease;
        }
        :host([data-open="true"])  .boms-custom-select_list {
            grid-template-rows: 1fr;
            padding: 10px;
        }
        .boms-custom-select_list-inner{
            display: flex;
            flex-direction: column;
            overflow-y: auto;
            overflow-x: hidden;
            scrollbar-color: #01BDFF #CACACA54;
            scrollbar-width: thin;
            max-height: 200px;
        }
        ::slotted(.option){
            cursor: pointer;
            transition: all 0.3s ease;
            font-size: 16px;
            font-weight: 300;
            line-height: 32px;
            text-align: left;
            padding: 5px 10px !important;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
            max-width: 100%;
        }
        ::slotted(.option:not(.nothing):hover) {
            background-color: #F6F6F6;
        }
        ::slotted(.text) {
            max-width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;
        }
        ::slotted(.img) {
            max-width: 10%;
        } 
        ::slotted(.option.nothing) {
            max-width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;
            color: #D1D1D1;
            font-weight: 300;
        }
        .boms-custom-select_list.top {
            top: calc(100% + 10px);
        }
        .boms-custom-select_list.bottom {
            bottom: calc(100% + 10px);
        }
        .boms-custom-select_selected-text {
            color: #00000080;
            text-overflow: ellipsis;
            display: block;
            overflow: hidden;
            text-wrap: nowrap;
            word-wrap: break-word;
        }
        :host([value]) .boms-custom-select_selected-text {
            color: #000;
        }
        @media only screen and (max-width: 780px){
            .boms-custom-select_selected {
                font-size: 14px;
            }
            .boms-custom-select_selected svg{
                width: 18px;
                height: 18px;
            }
        }
    </style>

    <div class="boms-custom-select_selected">
        <span class="boms-custom-select_selected-text"></span>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m19.5 8.25-7.5 7.5-7.5-7.5"
            />
        </svg>
    </div>
    <div class="boms-custom-select_list">
        <div class="boms-custom-select_list-inner">
            <slot></slot>
        </div>
    </div>
`;

class BomsCustomSelect extends HTMLElement {
  constructor() {
    super();
    const shadow = this.attachShadow({ mode: "open" });
    shadow.appendChild(templateBomsCustomSelect.content.cloneNode(true));

    this.selected = shadow.querySelector(".boms-custom-select_selected");
    this.list = shadow.querySelector(".boms-custom-select_list");
    this.selectedText = shadow.querySelector(
      ".boms-custom-select_selected-text"
    );

    this.selected.addEventListener("click", (e) => {
      //e.stopPropagation();
      this.dataset.open = !this.isOpen;
    });
    this.shadowRoot
      .querySelector("slot")
      .addEventListener("slotchange", this.handleSlotChange.bind(this));
    document.addEventListener("click", this.handleOutsideClick.bind(this));
  }

  connectedCallback() {}

  static get observedAttributes() {
    return ["value", "placeholder", "position", "open"];
  }

  get isOpen() {
    return this.dataset.open !== "false" && this.dataset.open !== null;
  }

  get value() {
    return this.getAttribute("value");
  }

  set value(value) {
    const oldValue = this.getAttribute("value");
    if (oldValue !== value) {
      this.setAttribute("value", value);
      const event = new CustomEvent("change", {
        detail: { value },
        bubbles: true,
        composed: true,
      });
      this.dispatchEvent(event);
    }
  }

  setSelectedText(value) {
    const slot = this.shadowRoot.querySelector("slot");
    const elements = slot.assignedElements();
    elements.forEach((element) => {
      if (
        element.getAttribute("value") === value) {
        this.selectedText.textContent = element.querySelector(".text").textContent.trim();
      }
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "placeholder") this.setplaceholder(newValue);
    if (name === "open") this.setOpen(newValue);
    if (name === "position") this.setListPosition(oldValue, newValue);
    if (name === "value") this.setSelectedText(newValue);
  }

  setplaceholder(value) {
    this.selectedText.textContent = value;
  }

  setListPosition(oldValue, newValue) {
    this.list.classList.remove(oldValue);
    this.list.classList.add(newValue);
  }

  handleOutsideClick(event) {
    if (!this.contains(event.target)) {
      this.dataset.open = "false";
    }
  }

  handleSlotChange() {
    const slot = this.shadowRoot.querySelector("slot");
    const elements = slot.assignedElements();
    elements.forEach((element) => {
      element.addEventListener("click", (e) => {
        //e.stopPropagation();
        if (!e.target.classList.contains("nothing")) {
          this.value =
          element.getAttribute("value");
            this.selectedText.textContent = element.querySelector(".text").textContent.trim();
        }
        this.dataset.open = "false";
      });
    });
  }
}

window.customElements.define("boms-custom-select", BomsCustomSelect);